import useFormAddReceiverStore from 'hooks/form-add-receiver/useFormAddReceiverStore';
import React, { useEffect } from 'react';

const withUpdateReceiverPageCleanup = (Component) => {
  const UpdateReceiverPageCleanupComponent = (props) => {
    const {
      setAddReceiverCurrentStep: setCurrentStep,
      resetAddReceiverInformation,
      resetCurrentReceiver,
    } = useFormAddReceiverStore();

    const cleanUpFn = () => {
      resetCurrentReceiver();
      resetAddReceiverInformation();
      setCurrentStep(0);
    };

    useEffect(() => {
      return () => {
        cleanUpFn();
      };
    }, []);

    const newProps = {
      ...props,
      cleanUpFn,
    };
    return <Component {...newProps} />;
  };
  return UpdateReceiverPageCleanupComponent;
};

export default withUpdateReceiverPageCleanup;
